import cookie from 'cookie';
import jwt_decode from 'jwt-decode';

const KEY_USER_ID_TOKEN = 'user_id_token';
const KEY_REFRESH_TOKEN = 'user_refresh_token';
const KEY_SPARKOL_TOKEN = 'token';
const KEY_UID = 'uid';
const ONE_MINUTE = 60 * 1000;

const getExpiresFromJwt = token => {
  let tokenObject;
  try {
    tokenObject = jwt_decode(token);
  } catch (error) {
    console.error(`Could not decode jwt. ${error.message}`);
    return null;
  }
  const { exp } = tokenObject;
  return new Date(exp * 1000);
};

export function calculateScheduleDelayTime() {
  const cookies = cookie.parse(document.cookie);
  const IdToken = cookies[KEY_USER_ID_TOKEN] || '';
  if (!IdToken) return 0;
  const expiryTime = getExpiresFromJwt(IdToken);
  const currentTime = new Date();
  return expiryTime - 10 * ONE_MINUTE - currentTime;
}

export function setSparkolToken(token, uid) {
  const path = '/';
  document.cookie = cookie.serialize(KEY_SPARKOL_TOKEN, token, { path });
  document.cookie = cookie.serialize(KEY_UID, uid, { path });
}

export function setUserTokens(userTokens = {}) {
  const { IdToken, RefreshToken } = userTokens;
  const path = '/';
  const expires = getExpiresFromJwt(IdToken);
  if (IdToken && expires) {
    document.cookie = cookie.serialize(KEY_USER_ID_TOKEN, IdToken, { expires, path });
  }
  if (RefreshToken) {
    document.cookie = cookie.serialize(KEY_REFRESH_TOKEN, RefreshToken, { path });
  }
}

export function getRefreshToken() {
  const cookies = cookie.parse(document.cookie);
  return cookies[KEY_REFRESH_TOKEN] || '';
}

export function getUID() {
  const cookies = cookie.parse(document.cookie);
  return cookies[KEY_UID] || '';
}

export function getSparkolToken() {
  const cookies = cookie.parse(document.cookie);
  return cookies[KEY_SPARKOL_TOKEN] || '';
}

export function removeSparkolToken() {
  const cookies = cookie.parse(document.cookie);
  const path = '/';

  if (typeof cookies[KEY_SPARKOL_TOKEN] === 'undefined') {
    return;
  }

  document.cookie = cookie.serialize(KEY_SPARKOL_TOKEN, false, { maxAge: -1, expires: new Date(), path });
  document.cookie = cookie.serialize(KEY_UID, false, { maxAge: -1, expires: new Date(), path });
}

export function removeUserTokens() {
  const cookies = cookie.parse(document.cookie);
  const path = '/';

  if (typeof cookies[KEY_USER_ID_TOKEN] === 'string') {
    document.cookie = cookie.serialize(KEY_USER_ID_TOKEN, false, { maxAge: -1, expires: new Date(), path });
  }

  if (typeof cookies[KEY_REFRESH_TOKEN] === 'string') {
    document.cookie = cookie.serialize(KEY_REFRESH_TOKEN, false, { maxAge: -1, expires: new Date(), path });
  }
}

export function removeAuthTokens() {
  removeSparkolToken();
  removeUserTokens();
}
